/**
 * Environment configuration
 */
export const config = {
	ENVIRONMENT: process.env.REACT_APP_ENV,
	API_URL: process.env.REACT_APP_API_URL,
	STATIC_URL: process.env.REACT_APP_STATIC_URL,
};
